import * as React from 'react';
import { SVGProps } from 'react';

const IconMaxHeightSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 14h5.571L5 11h2V5H5l2.571-3H2V0h12v2H8.429L11 5H9v6h2l-2.571 3H14v2H2v-2z" />
  </svg>
);
export default IconMaxHeightSizeS;
